// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"525":"54b86a62","898":"a3b5af71","998":"910f1f5d"}[chunkId] + ".chunk.css";
};